<template>
  <div
    class="rt-lookup"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    @click="show"
  >
    <div v-if="multiple" class="multiple-lookup-wrap">
      <div v-if="list && list.length > 0" class="lookup-main">
        <template v-if="max">
          <div
            v-for="(item, index) in list.slice(0, 2)"
            :key="index"
            class="tag"
          >
            <span class="tag-text">{{ item[alias.name] }}</span>
            <rt-icon
              class="tag-close"
              name="rt-base-close_fill"
              @click.stop="del(index)"
            />
          </div>
          <el-popover
            ref="popover"
            :content="contentPopover"
            trigger="hover"
            @show="showPopover"
          >
            <div slot="reference" class="tag">
              <span class="tag-text tag-num">+ {{ list.length - 2 }}</span>
            </div>
          </el-popover>
        </template>
        <template v-else>
          <div v-for="(item, index) in list" :key="index" class="tag">
            <span class="tag-text">{{ item[alias.name] }}</span>
            <rt-icon
              class="tag-close"
              name="rt-base-close_fill"
              @click.stop="del(index)"
            />
          </div>
        </template>
      </div>
      <div v-else class="select-placeholder">
        <span>请选择</span>
      </div>
    </div>
    <div v-if="!multiple" class="single-lookup-wrap">
      <el-input
        :disabled="disabled"
        :value="inputText"
        :placeholder="placeholder"
        readonly
      />
    </div>
    <rt-icon v-show="!showClose && !disabled" name="rt-base-lookup" />
    <rt-icon v-if="showClose" name="rt-base-close" @click.stop="clear" />
    <rt-dialog
      :append-to-body="true"
      v-model="visible"
      :title="title"
      class="lookup-dialog"
      size="large"
      @confirm="confirm"
      @cancel="cancel"
    >
      <rt-lookup-view
        ref="lookupView"
        :fetch="fetchRecord"
        :display-fields="displayFields"
        :multiple="multiple"
        :title="title"
        :total="total"
        @change="change"
      />
    </rt-dialog>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtDialog from '../dialog/rtDialog';
import RtLookupView from './rtLookupView';
import mixin from './mixin.js';
export default {
  name: 'RtLookup',
  components: {
    RtIcon,
    RtDialog,
    RtLookupView
  },
  mixins: [mixin],
  props: {
    fetch: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    del(index) {
      if (this.disabled) {
        return;
      }
      this.list.splice(index, 1);
      this.$emit('input', this.list);
      this.$emit('confirm', this.list);
    },
    clear() {
      if (this.disabled) {
        return;
      }
      if (this.multiple) {
        this.list = [];
        this.$emit('input', this.list);
        this.$emit('confirm', this.list);
      } else {
        const obj = {};
        this.inputText = '';
        obj[this.alias.id] = '';
        obj[this.alias.name] = '';
        this.$emit('input', obj);
        this.$emit('confirm', obj);
      }
    },
    confirm() {
      const obj = {};
      const { selected, multiple, alias } = this;
      let id = '';
      let name = '';
      if (this.multiple) {
        // id = selected ? selected.map(item => item[alias.id]).join(',') : '';
        // name = selected ? selected.map(item => item[alias.name]).join(',') : '';
        this.list = selected ? selected : [];
        this.$emit('input', this.list);
        this.$emit('confirm', this.list);
      } else {
        id = selected ? selected[alias.id] : '';
        name = selected ? selected[alias.name] : '';
        obj[alias.id] = id;
        obj[alias.name] = name;
        this.$emit('input', obj);
        this.$emit('confirm', obj);
      }
      this.selected = null;
      this.$refs.lookupView.$refs.table.$refs.table.clearSelection();
    },
    fetchRecord(params) {
      if (this.fetch) {
        return this.fetch(params).then(res => {
          this.total = res.total;
          return res.data;
        });
      } else {
        return this.$lookup.getLookupData(params).then(res => {
          this.total = res.total;
          return res.data;
        });
      }
    },
    // 处理设置最多显示项时，剩余数量的popover的内容
    // 处理逻辑是slice(max值)数据list，循环拼接每一项的内容给到最后赋值给popover content的变量
    // 因UI设计最后一条无分号，拼接后做了substring去掉最后一个 ‘分号’ 字符
    showPopover() {
      let str = '';
      this.list.slice(2).forEach(item => {
        str += item[this.alias.name] + ';';
      });
      str = str.substring(0, str.length - 1);
      this.contentPopover = str;
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-lookup {
  border-bottom: 1px solid #e8ecfc;
  .multiple-lookup-wrap {
    max-width: 90%;
    .lookup-main {
      line-height: 28px;
      .tag {
        margin: 0px 8px 4px 0px;
        padding: 2px 8px;
        border: 1px solid #e8ecfc;
        border-radius: 2px;
        white-space: nowrap;
        background: #f5f7fa;
        display: inline-flex;
        align-items: center;
        .tag-text {
          color: #143e81;
          padding-right: 8px;
          font-family: 'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', Arial,
            sans-serif;
          font-size: 14px;
          line-height: 19px;
          white-space: pre-wrap;
        }
        .tag-num {
          padding-right: 0;
        }
        .tag-close {
          position: unset;
        }
      }
    }
    .select-placeholder {
      height: 28px;
      line-height: 28px;
      color: #ced5ef;
      span {
        font-size: 14px;
      }
    }
  }
  .single-lookup-wrap {
    width: 100%;
  }
}
.lookup-dialog {
  @{deep} {
    .el-input__suffix {
      .el-icon-circle-check,
      .el-icon-circle-close,
      .el-icon-loading {
        display: none;
      }
    }
    .el-pagination__total {
      padding-right: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtLookup.vue?27f30be8